import React from 'react';
var ContentfulContext = /*#__PURE__*/React.createContext(null);
export default ContentfulContext;